import React, { useState, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '../util/buttons';
import CostFieldsPopover from './components/CostFieldsPopover';
import ProjectTemplateExportsTable from './ProjectTemplateExportsTable';
import claimCostTemplateExportsService from './claim_cost_template_exports.service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { buildQueryString } from '../services/service';
export default function ClaimCostExportTab(_ref) {
  var _claimGroup$claims, _claimGroup$claims2;
  let {
    claimGroup,
    userCanDelete = true,
    showDownloadTemplateButton = false
  } = _ref;
  const allFields = window.MARKET_CONSTANTS.COST_EXPORT_FIELDS_LIST;
  const {
    t
  } = useTranslation();
  const [selectedFields, setSelectedFields] = useState(allFields);
  const [selectedClaimId, setSelectedClaimId] = useState((_claimGroup$claims = claimGroup.claims) !== null && _claimGroup$claims !== void 0 && _claimGroup$claims.length ? String(claimGroup.claims[0].id) : null);
  const [loading, setLoading] = useState(false);
  const [templateDownloading, setTemplateDownloading] = useState(false);
  const {
    exports,
    createExport,
    deleteExport
  } = claimCostTemplateExportsService.useCrud(setLoading, selectedClaimId);
  const handleGenerateExport = useErrorHandling(useCallback(async () => {
    if (!selectedClaimId || selectedFields.length === 0) return;
    setLoading(true);
    await createExport(selectedFields);
  }, [selectedClaimId, selectedFields, createExport]), () => setLoading(false));
  const handleDeleteExport = useErrorHandling(useCallback(async exportId => {
    setLoading(true);
    await deleteExport(exportId);
  }, [deleteExport]), () => setLoading(false));
  const handleDownloadTemplate = useErrorHandling(useCallback(async () => {
    if (!selectedClaimId) return;
    setTemplateDownloading(true);
    const queryString = buildQueryString({
      from: null,
      to: null
    });
    window.open("/api/claims/".concat(selectedClaimId, "/claim_export_cost_template?").concat(queryString));
    setTemplateDownloading(false);
  }, [selectedClaimId]), () => setTemplateDownloading(false));
  const hasMultipleClaims = ((_claimGroup$claims2 = claimGroup.claims) === null || _claimGroup$claims2 === void 0 ? void 0 : _claimGroup$claims2.length) > 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-100 p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3 mb-4 flex-wrap"
  }, hasMultipleClaims && /*#__PURE__*/React.createElement(Form.Select, {
    style: {
      width: '220px'
    },
    value: selectedClaimId,
    onChange: e => setSelectedClaimId(e.target.value),
    disabled: loading
  }, claimGroup.claims.map(claim => /*#__PURE__*/React.createElement("option", {
    key: claim.id,
    value: String(claim.id)
  }, claim.name))), /*#__PURE__*/React.createElement(CostFieldsPopover, {
    selectedFields: selectedFields,
    setSelectedFields: setSelectedFields
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: handleGenerateExport,
    size: "md",
    variant: "info",
    iconPosition: "left",
    icon: "download",
    style: {
      width: '240px'
    },
    disabled: loading || !selectedClaimId || selectedFields.length === 0
  }, loading ? t('generating') : t('export_cost_data')), showDownloadTemplateButton && /*#__PURE__*/React.createElement(Button, {
    onClick: handleDownloadTemplate,
    size: "md",
    variant: "info",
    iconPosition: "left",
    icon: "download",
    style: {
      width: '240px'
    },
    disabled: templateDownloading || !selectedClaimId
  }, templateDownloading ? t('generating') : t('download_cost_template'))), /*#__PURE__*/React.createElement("hr", {
    className: "my-4"
  }), /*#__PURE__*/React.createElement("h6", {
    className: "text-primary mb-3"
  }, t('export_history')), /*#__PURE__*/React.createElement(ProjectTemplateExportsTable, {
    exports: exports,
    loading: loading,
    onDelete: handleDeleteExport,
    userCanDelete: userCanDelete
  }));
}